import { render, staticRenderFns } from "./EventBadgeConstructor.vue?vue&type=template&id=f6597cc8&scoped=true"
import script from "./EventBadgeConstructor.vue?vue&type=script&lang=js"
export * from "./EventBadgeConstructor.vue?vue&type=script&lang=js"
import style0 from "./EventBadgeConstructor.vue?vue&type=style&index=0&id=f6597cc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6597cc8",
  null
  
)

export default component.exports